import useStyles from 'isomorphic-style-loader/useStyles'
import React, { useCallback, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { fetchCancelOrder, fetchMssageByTypeCode } from '../../../../../../../api'
// import Alert from '../../../../../../components/alert/index'
import { action_fetch_cart } from '../../../../../../../store/actions/pages/cart'
// import NormalConfigConfirm from '../../../../../../components/alert/config-confirm'
import { BigButton } from '../../../../../../components/button'
import CountDown from '../../../../../../components/count-down/count-down'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { BlackMask } from '../../../../../../components/mask'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { fetchUnifiedProcessing } from '../../../../../me/utils'
import classes from './style.module.scss'
import { TOOGLE_UI_ALERT, TOOGLE_UI_CONFIRM } from '../../../../../../../store/actions/ui'

const CancelOrderReason = props =>{
    const { orderId, onClose } = props;
    const [reasons, setReasons] = useState(null);
    const [reasonValue, setReasonValue] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()

    useEffect(async () =>{
        let response = await fetchMssageByTypeCode('cancel-order-reasons');
        setReasons(fetchUnifiedProcessing(response));
    }, []);

    const submitHandle = useCallback(async (value, orderId) =>{
        setLoading(true);
        let response = await fetchCancelOrder({orderId, cancelReason:value});
        if(response?.code === 200){
            onClose?.();
            await dispatch(action_fetch_cart())
            window.location.replace(`/user/order/detail/${orderId}`)
            return
        }else{
            onClose?.();
            if(response?.result){
                dispatch({
                    type: TOOGLE_UI_ALERT,
                    payload: {
                        show: true,
                        options: {
                            content: response.result,
                            onConfirm: () => {
                                dispatch({ type: TOOGLE_UI_ALERT, options: null })
                            }
                        }
                    }
                })
            }
        }
        setLoading(false);
    }, []);

    return <div className={classes.CancelOrderReason}>
        <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe69a;</Iconfont>

        <div className={classes.Title}>
            <FormattedMessage id="select_reason" defaultMessage="Select a reason" />
        </div>

        {
            reasons?.length > 0 ? <div className={classes.ReasonList}>
                {
                    reasons.map((reason, index) =>(
                        <div className={classes.ReasonItem} key={index} onClick={() => setReasonValue(reason?.value)}>
                            <span>{reason?.label}</span>

                            <input type="radio" className={`${reason.value===reasonValue?classes.Active:''}`} />
                        </div>
                    ))
                }
            </div> : <div className={classes.ReasonListLoading}><FormattedMessage id="loading" defaultMessage="Loading" />...</div>
        }

        <div className={classes.SubmitButton}>
            <BigButton onClick={() =>submitHandle(reasonValue, orderId)} loading={loading} disabled={!reasonValue}><FormattedMessage id="submit" defaultMessage="Submit" /></BigButton>
        </div>
    </div>
}

const CancelOrderReasonModal = props =>{
    useStyles(classes)
    const { show, onClose } = props;

    return <React.Fragment>
        <BottomToTop in={show} className={classes.CancelOrderReasonModal}>
            <div>
                <CancelOrderReason {...props} />
            </div>
        </BottomToTop>

        {
            show && <BlackMask onClick={onClose} />
        }
    </React.Fragment>
}

const OrderCancelButton = props => {
    const {order} = props
    useStyles(classes)
    const Intl = useIntl()
    const [showReasonMask, setShowReasonMask] = useState(false)
    const dispatch = useDispatch()

    const getRemainingTime = () => {
		let checkout = order
		if (checkout && checkout.serverTime && checkout.expiredPaymentTime) {
			return checkout.expiredPaymentTime - checkout.serverTime
		} else {
			return ''
		}
	}

    const orderCancelHandle = () => {
        // NormalConfigConfirm({
        //     message:{
        //         text: <span style={{color: '#e96060'}}>
        //             {Intl.formatMessage({ id: "cancel_info", defaultMessage: "Are you sure you want to cancel payment? If your order is not paid in {countdown},it will be canceled." }, {countdown: <CountDown offset={getRemainingTime()} showHour style={{margin: '0 3px', color: '#e96060'}} />})}
        //         </span>,
        //     },
        //     btn1:{
        //         text: Intl.formatMessage({id: 'confirm_cancel', defaultMessage: 'Confirm Cancel'}),
        //         style:{textTransform: 'capitalize'},
        //         clickHandle:()=>{
        //             // 同意cancel
        //             setShowReasonMask(true)
        //         }
        //     },
        //     btn2:{
        //         style:{textTransform: 'capitalize'},
        //         text: Intl.formatMessage({id: 'continue_to_pay', defaultMessage: 'Continue To Pay'}),
        //     }
        // });

        dispatch({
            type: TOOGLE_UI_CONFIRM,
            payload: {
                show: true,
                options: {
                    onConfirm: () => {
                        setShowReasonMask(true)
                        dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                    },
                    onCancel: () => {
                        dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                    },
                    content: <span style={{color: '#e96060'}}>
                                {Intl.formatMessage({ id: "cancel_info", defaultMessage: "Are you sure you want to cancel payment? If your order is not paid in {countdown},it will be canceled." }, {countdown: <CountDown offset={getRemainingTime()} showHour style={{margin: '0 3px', color: '#e96060'}} />})}
                            </span>,
                    okText: <span style={{textTransform: 'capitalize'}}>{Intl.formatMessage({id: 'confirm_cancel', defaultMessage: 'Confirm Cancel'})}</span>,
                    cancelText: <span style={{textTransform: 'capitalize'}}>{Intl.formatMessage({id: 'continue_to_pay', defaultMessage: 'Continue To Pay'})}</span>
                }
            }
        })
    }

    return (<React.Fragment>
        <div className={classes.ButtonLine}>
            <div className={classes.OrderCancelButton} onClick={() => orderCancelHandle()}>
                {Intl.formatMessage({id: 'cancel_order', defaultMessage: 'Cancel Order'})}
            </div>
        </div>

        <CancelOrderReasonModal show={showReasonMask} orderId={order?.orderId} onClose={() => setShowReasonMask(false)}/>
    </React.Fragment>)
}

export default OrderCancelButton